export interface ToastOptions {
  message: string
  type?: 'success' | 'error' | 'warning' | 'info'
  timeout?: number
}

interface ToastState {
  show: boolean
  message: string
  type: 'success' | 'error' | 'warning' | 'info'
  timeout: number
}

const DEFAULT_TIMEOUT = 4000

export const useToast = () => {
  const state = useState<ToastState>('toast', () => ({
    show: false,
    message: '',
    type: 'success',
    timeout: DEFAULT_TIMEOUT,
  }))

  function show(options: ToastOptions) {
    state.value = {
      show: true,
      message: options.message,
      type: options.type || 'success',
      timeout: options.timeout || DEFAULT_TIMEOUT,
    }
  }

  function hide() {
    state.value.show = false
  }

  function success(message: string, timeout?: number) {
    show({ message, type: 'success', timeout })
  }

  function error(message: string, timeout?: number) {
    show({ message, type: 'error', timeout: timeout || 6000 })
  }

  function warning(message: string, timeout?: number) {
    show({ message, type: 'warning', timeout })
  }

  function info(message: string, timeout?: number) {
    show({ message, type: 'info', timeout })
  }

  return {
    state,
    show,
    hide,
    success,
    error,
    warning,
    info,
  }
}
